import classNames from 'classnames';
import H from 'history';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { withPermissionCheck } from '../Auth/PermissionsCheck';
import styles from './NavMenu.module.scss';

type NavMenuItemProps = {
    icon: JSX.Element;
    title: string;
    pathname: string;
    location: string;
    disabled?: boolean;
    referrerLocation?: H.Location;
    isNavModal?: boolean;
    replace?: boolean;
    collapses?: boolean;
    exact?: boolean;
    onClick?(e: React.MouseEvent<HTMLAnchorElement>): void;
};

export const NavMenuItem = (props: NavMenuItemProps) => {
    const textClass = classNames(styles.text, {
        [styles.navCollapses]: props.collapses,
        [styles.textDisabled]: props.disabled
    });

    if (props.disabled) {
        const disabledLink = classNames(styles.link, {
            [styles.linkDisabled]: props.disabled
        });
        return (
            <div className={disabledLink}>
                {React.cloneElement(props.icon, { className: styles.icon })}
                <div className={textClass}>{props.title}</div>
            </div>
        );
    }

    return (
        <NavLink
            to={{ pathname: props.location, state: { referrer: props.referrerLocation, modal: props.isNavModal } }}
            exact={props.exact}
            title={props.title}
            replace={props.replace}
            className={styles.link}
            activeClassName={styles.linkActive}
            onClick={props.onClick}
        >
            {React.cloneElement(props.icon, { className: styles.icon })}
            <div className={textClass}>{props.title}</div>
        </NavLink>
    );
};

export const NavMenuItemWithPermission = withPermissionCheck<NavMenuItemProps>(NavMenuItem);

export const NavMenu: React.FC<{
    collapses?: boolean;
    isCollapsed?: boolean;
}> = props => {
    const navMenuClass = classNames(styles.links, {
        [styles.collapsed]: props.isCollapsed
    });

    return (
        <div className={navMenuClass}>
            {React.Children.map(props.children, (child: any) => {
                if (!!child) return React.cloneElement(child, { collapses: props.collapses });

                return null;
            })}
        </div>
    );
};
